import Vue from 'vue'
import { createPlatformState, platformAction, platformGetters, platformMutations } from '~/helpers/store'

export default {
  state: () => createPlatformState(),
  actions: {
    async createInquiry ({ commit }, data) {
      const res = await platformAction({
        client: this.$api.support.inquiries,
        method: 'create',
        commit,
        logError: this.$logError,
        params: data
      })

      if (res && res.id) {
        commit('setRecentlyCreated', res.id)
      }
    }
  },
  getters: {
    ...platformGetters,
    getRecentlyCreatedId: s => {
      if (s.meta.recent) {
        return s.meta.recent
      }
      return null
    }
  },
  mutations: {
    ...platformMutations,
    setRecentlyCreated: (s, id) => {
      Vue.set(s.meta, 'recent', id)
    }
  }
}
